import { PiPlusCircleBold } from 'react-icons/pi';

interface PlusProps {
  className?: string;
  onClick: () => void;
}

export function Plus({ onClick, className }: PlusProps) {
  return (
    <div className={`${className} flex flex-col items-center`}>
      <button className="btn btn-circle btn-lg btn-ghost" onClick={onClick}>
        <PiPlusCircleBold className="text-primary" size={'3rem'} />
      </button>
    </div>
  );
}
